import {useDispatch, useSelector} from "react-redux";
import {StoreState} from "../../../reducers";
import {Studio} from "../../../actions/studio";
import {loadStripe} from "@stripe/stripe-js/pure";
import React, { useEffect, useState} from "react";
import {Stripe} from "@stripe/stripe-js";
import {useLocation, useNavigate} from "react-router-dom";
import {addCoupon, CheckoutState} from "../../../actions/checkout";
import baseApi from "../../../apis/baseApi";
import {getApiErrorMessage} from "../../../utils/api_utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import {EmbeddedCheckout, EmbeddedCheckoutProvider} from "@stripe/react-stripe-js";
import {Field, Form, Formik} from "formik";
import {Coupon} from "../../../data/Coupon";
import FieldError from "../../misc/FieldError";
import {Button} from "react-bootstrap";

interface Props {
    stripePromise: Promise<Stripe | null>
}

const EmbeddedStripeCheckout = ({stripePromise}: Props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const checkoutState = useSelector<StoreState, CheckoutState>(state => state.checkout)
    const [errorMsg, setErrorMsg] = useState<string>();
    const [clientSecret, setClientSecret] = useState<string>();
    const [checkoutSuccess, setCheckoutSuccess] = useState(false);



    useEffect(() => {
        // Create a Checkout Session
        let planId = checkoutState.selectedPlan!.id
        let promotion = checkoutState.selectedPlan!.promotions.length === 0 ? undefined : checkoutState.selectedPlan?.promotions[0].id
        baseApi.post("/stripe/plan/checkout-session/", {
            plan: planId,
            promotion: promotion,
            coupon_code: checkoutState.coupon?.redeem_code,
        }).then(resp => {
            setClientSecret(resp.data.client_secret)
        }).catch(err => {setErrorMsg(getApiErrorMessage(err))})
    }, [checkoutState]);

    if (!checkoutState.selectedPlan) {
        navigate("/", {replace: true})
        return <React.Fragment/>
    }
    return (
        <div>
            <div
                className="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-6 bg-white my-5 shadow-lg rounded-xl mx-auto pb-10">
                {/* BACK BUTTON AND CONFIRM TEXT */}
                <div className="d-flex text-center align-items-center mb-2 pt-3">
                    <button className="btn mr-auto" onClick={() => {
                        navigate(-1)
                    }}><FontAwesomeIcon icon={faChevronLeft}/>
                    </button>
                    {/*<p className={"font-size-h6 align-self-center ml-2"}>Agregar método de pago</p>*/}
                    <div className="text-center font-size-h3 ml-n10  mr-auto">Confirma tu compra</div>
                </div>


                {/* ERROR */}
                <div hidden={checkoutState.error === undefined}
                     className="alert alert-danger">Error: {checkoutState.error}
                </div>

                <div className="text-center text-danger">
                    {errorMsg}
                </div>
                <div id="checkout">
                    <div key={clientSecret}>
                        <EmbeddedCheckoutProvider
                            stripe={stripePromise}
                            options={{
                                clientSecret: clientSecret,
                                onComplete: () => {
                                    setCheckoutSuccess(true)
                                }
                            }}
                        >
                            <EmbeddedCheckout/>
                        </EmbeddedCheckoutProvider>
                    </div>
                </div>

                <div className="row justify-content-center mt-5">
                    <div className="">
                        {/* CUPON */}
                        <div className="mt-2">
                            <Formik initialValues={{coupon_code: checkoutState?.coupon?.redeem_code} as any}
                                    onSubmit={(values, {setSubmitting, setFieldError}) => {
                                        baseApi.post<Coupon>("/coupons/validate/", {
                                            ...values,
                                            plan: checkoutState.selectedPlan!.id,
                                        }).then(resp => {
                                            dispatch(addCoupon(resp.data))
                                        }).catch(err => {
                                            setFieldError("coupon_code", getApiErrorMessage(err))
                                            setSubmitting(false)
                                        })
                                    }}>
                                {({values, isSubmitting}) => (
                                    <Form hidden={checkoutSuccess}>
                                        <div className="d-flex px-6">
                                            <div className="w-75">
                                                <Field name="coupon_code"
                                                       className="form-control form-control-"
                                                       placeholder="Código de descuento"/>
                                                <FieldError name="coupon_code"/>
                                            </div>
                                            <div className="">
                                                <Button className='font-size-sm text-success'
                                                        type="submit"
                                                        disabled={isSubmitting} variant="outline-secondary"
                                                >
                                                    {/* <FontAwesomeIcon icon={faCheck}/> */}
                                                    Aplicar
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                            <div hidden={!checkoutState.coupon}
                                 className="text-success text-center">{checkoutState.coupon?.title} (-{checkoutState.coupon?.discount_amount}{checkoutState.coupon?.is_percent ? '%' : ''})
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

const Wrapper = () => {
    const location = useLocation()
    const studio = useSelector<StoreState, Studio>(state => state.studio.studio)
    const params = new URLSearchParams(location.search)
    const branchId = params.get('branch') || undefined
    let publicKey = studio.preferences.public
    console.log(publicKey)
    if (branchId) {
        console.log("ON BRANCH")
        let branch = studio.branches.find(b => b.id === branchId)
        console.log(branch?.name)
        console.log(branch?.public_key)
        if (branch?.public_key) {
            publicKey = branch.public_key
        }
    }
    console.log(`USE PUBLIC KEY: ${publicKey}`)
    const stripePromise = loadStripe(publicKey, {locale: "es"})
    return <EmbeddedStripeCheckout stripePromise={stripePromise}/>
}

export default Wrapper;